module.exports = __webpack_public_path__ + "img/emoji_13.d3a9667c.png";